import { DayOfWeekInstanceSchedule } from '../schema/day-of-week-instance-schedule.schema';
import { DayOfWeekInstanceScheduleValidator } from '../validators/index';

export const isDayOfWeekInstanceSchedule = (
  value: unknown,
): value is DayOfWeekInstanceSchedule =>
  DayOfWeekInstanceScheduleValidator.Check(value);
